import script from "./translations.vue?vue&type=script&lang=js"
export * from "./translations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/translations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ec25fac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ec25fac', __exports__)) {
    api.reload('9ec25fac', __exports__)
  }
  
}


export default __exports__